module.exports = __webpack_public_path__ + "media/images/logo-13e5e19c20b6edd941b0ababdebc7795.svg";